import { Container, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { ReelPanel, SlotConstants, SlotEventConstants, SymbolFactory } from "@quest/slot-core";
import { IGame } from "@quest/adapter-interface";
import { Graphics } from "@quest/pixi-bridge";
import { HoldAndRespinReel } from "./HoldAndRespinReel";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { HoldAndRespinReelModel } from "../Model/HoldAndRespinReelModel";

export class HoldAndRespinReelPanel extends Container {
    private model: HoldAndRespinReelModel
    protected reels: Array<HoldAndRespinReel>;
    protected stopPos: number[] = [];
    protected initiated: boolean = false;
    protected isSpining: boolean;
    protected spinAll: boolean = false;
    protected reelsStopped: boolean[];
    protected stopSpinAll: boolean;
    protected paused: boolean = false;
    protected stopNow: boolean = false;
    protected reelPanel: ReelPanel;
    constructor(currentGame: IGame, model: HoldAndRespinReelModel) {
        super(model.json, ingenuity.currentGame);
        this.model = model;
        this.reels = [];
        this.reelsStopped = [];
        const symbolPool: any = new SymbolFactory(this.model);
        for (let i = 0; i < this.model.getNumReels(); i++) {
            this.reels.push(new HoldAndRespinReel(i, this.model.getSymPerReel(i), this.model, symbolPool));
            this.addChild(this.reels[i]);
        }
        this.reelpanelMaskOn();
    }
    public unsubscribeEvents(): void {
        for (let i = 0; i < this.model.getNumReels(); i++) {
            dispatcher.off(SlotEventConstants.REEL_MASK_ON, this.reels[i].reelMaskOn, this.reels[i]);
        }
    }
    /**
    * Initialize reels
    */
    public init(stops: any): void {
        for (let i = 0; i < this.model.getNumReels(); i++) {
            if (!Array.isArray(stops)) {
                this.reels[i].init(stops);
            } else {
                this.reels[i].init(stops[i]);
            }
            dispatcher.on(SlotEventConstants.REEL_MASK_ON, this.reels[i].reelMaskOn, this.reels[i]);

            if (!this.reels[i].hasEvent(eventDispatchers.FEATURE_REEL_STOPPED)) {
                this.reels[i].on(eventDispatchers.FEATURE_REEL_STOPPED, this.reelStopped, this, false);
            }
            if (!this.reels[i].hasEvent(eventDispatchers.FEATURE_REEL_STOPPING)) {
                this.reels[i].on(eventDispatchers.FEATURE_REEL_STOPPING, this.onReelStopping, this, false);
            }
        }
        this.initiated = true;
    }
    /**
    * Show reel view
    */
    public showView(): void {
        this.visible = true;
    }
    /**
    * Hide reel view
    */
    public hideView(): void {
        this.visible = false;
    }

    /**
    * Show the Reels
    */
    public showReels(): void {
        for (let i = 0; i < this.model.getNumReels(); i++) {
            this.reels[i].visible = true;
        }
    }
    /**
    * Hide the Reels
    */
    public hideReels(reelId: number): void {
        this.reels[reelId].visible = false;
    }

    /**
    * Reel mask
    */
    protected reelpanelMaskOn() {
        if (Array.isArray(this.model.json.mask) && this.model.json.mask[0] === "reelpanel") {
            if (this.model.json.commandArray) {
                if (!this.mask) {
                    (this.mask as Graphics) = new Graphics(this.game, this.model.json.reelpanelMask[0], this.model.json.reelpanelMask[1]);
                    let commandLen: number = this.model.json.commandArray.length;
                    (this.mask as Graphics).beginFill(0xf00);
                    (this.mask as Graphics).moveTo(this.model.json.commandArray[0][0], this.model.json.commandArray[0][1]);
                    for (let i: number = 1; i < commandLen; i++) {
                        (this.mask as Graphics).lineTo(this.model.json.commandArray[i][0], this.model.json.commandArray[i][1]);
                    }
                    this.addChild(this.mask);
                }
            } else if (this.model.json.reel) {
                if (!this.mask) {
                    (this.mask as Graphics) = new Graphics(this.game, this.model.json.reel[0], this.model.json.reel[1]);
                    (this.mask as Graphics).beginFill(0xf00);
                    (this.mask as Graphics).drawRect(0, 0, this.model.json.reel[2], this.model.json.reel[3]);
                    this.addChild(this.mask);
                }
            } else {
                throw new Error("Please define a proper config element for reelpanelMask");
            }
        }

    }



    /**
      * Start spining
      */
    public featureReelSpin(): void {
        const isBlur = false;
        if (!this.initiated) {
            throw new Error("Can not Spin, Reels Not initiated");
        }
        dispatcher.fireEvent(SlotEventConstants.CLEAR_ANIM_LAYER);
        let i = 0;
        if (this.model.noStartDelay) {
            for (i = 0; i < this.reels.length; i++) {
                this.reels[i].spin(isBlur);
            }
            this.isSpining = true;
        } else if (this.model.reelsJson[i].noDelay) {
            this.spinReel.bind(this, i, isBlur);
        } else {
            let delay: number = Array.isArray(this.model.startDelay) ? this.model.startDelay[i] : this.model.startDelay;
            delayedCall(SlotConstants.StartSpinTimer + i, delay, this.spinReel.bind(this, i, isBlur), this);
        }
        this.stopSpinAll = false;
        this.spinAll = true;
        this.reelsStopped.length = 0;
        dispatcher.fireEvent(SlotEventConstants.REEL_MASK_ON);
        ingenuity.currentGame.ticker.add(this.update, this);
    }

    /**
      * Reel spin
      */
    protected spinReel(id: number, isBlur: boolean) {
        this.reels[id].spin(isBlur);
        id++;
        if (id < this.reels.length) {
            if (this.model.reelsJson[id].noDelay) {
                this.spinReel.bind(this, id, isBlur);
            } else {
                let delay: number = Array.isArray(this.model.startDelay) ? this.model.startDelay[id] : this.model.startDelay;
                delayedCall(SlotConstants.StartSpinTimer + id, delay, this.spinReel.bind(this, id, isBlur), this);
            }
        }
        if (id === this.reels.length) {
            this.isSpining = true;
        }
    }

    /**
      * while spining update will call
      */
    public update() {
        super.update.call(this);
        if (this.paused) {
            return;
        }
        if (!this.spinAll) {
            return;
        }
        let len = this.reels.length, i;
        let deltaTime = ingenuity.currentGame.time.elapsedMS;
        for (i = 0; i < len; i++) {
            this.reels[i].updateSpin(deltaTime);
        }
        if (this.stopSpinAll) {
            this.spinAll = false;
            this.stopSpinAll = false;
            this.isSpining = false;
            ingenuity.currentGame.ticker.remove(this.update, this);
        }
    }
    /**
    * start stoping reels
    */
    public stop(stops: any) {
        killDelayedCall(SlotConstants.StopSpinTimer);
        if (!this.isSpining) {
            delayedCall(SlotConstants.StopSpinTimer, 100, this.stop.bind(this, stops), this, stops);
            return;
        }
        let i: number = 0;
        if (Array.isArray(stops)) {
            this.model.reelStops = stops;
        } else if (typeof stops === "object" && stops && stops.data) {
            if (Array.isArray(stops.data)) {
                this.model.reelStops = stops.data;
            } else {
                throw new Error("No response recived or response not in the form of an Array" + stops.data);
            }
        } else {
            throw new Error("No response recived or response not in the form of an Array" + stops);
        }

        if (this.model.noStopDelay) {
            for (i = 0; i < this.reels.length; i++) {
                this.reels[i].setStops(stops[i]);
            }
        } else if (this.model.reelsJson[i].noDelay) {
            this.stopReel.bind(this, i, true);
        } else {
            let delay: number = Array.isArray(this.model.stopDelay) ? this.model.stopDelay[i] : this.model.stopDelay;
            delayedCall(SlotConstants.StopReelId + i, delay, this.stopReel.bind(this, i, true));
        }
    }
    /**
    * stop reel
    */
    protected stopReel(id: number, allReelSpining: boolean) {
        if (!allReelSpining) {
            return;
        }
        if (this.reels[id].getIsSpining() && !this.paused) {
            if (this.model.reelStops.length) {
                this.reels[id].setStops(this.model.reelStops[id]);
            } else {
                this.reels[id].setStops(this.model.reelGrid[id]);
            }
            id++;
            if (id < this.reels.length) {
                let delay: number = Array.isArray(this.model.stopDelay) ? this.model.stopDelay[id] : this.model.stopDelay;
                if (this.model.anticipationSpin[id]) {
                    delay = this.model.getAnticipationDelay(id);
                }
                if (this.model.reelsJson[id].noDelay) {
                    this.stopReel.bind(this, id, this.isSpining);
                } else if (ingenuity.configData.stopNowWithDelay && this.stopNow) {
                    delayedCall(SlotConstants.StopReelId + id, ingenuity.configData.stopNowWithDelay, this.stopReel.bind(this, id, this.isSpining));
                } else {
                    delayedCall(SlotConstants.StopReelId + id, delay, this.stopReel.bind(this, id, this.isSpining));
                }
            }
        } else {
            if (ingenuity.configData.stopNowWithDelay && this.stopNow) {
                delayedCall(SlotConstants.StopReelId + id, ingenuity.configData.stopNowWithDelay / 2, this.stopReel.bind(this, id, this.isSpining));
            } else {
                let delay: number = Array.isArray(this.model.stopDelay) ? this.model.stopDelay[id] : this.model.stopDelay;
                delayedCall(SlotConstants.StopReelId + id, delay / 4, this.stopReel.bind(this, id, this.isSpining));
            }
        }
    }
    /**
      * This function is called when the reel's stop bounce starts and this is triggered from the reel and is fired from the reelpanel.
      * @param evt
      */
    protected onReelStopping(evt?: any) {
        if (dispatcher.hasEvent(eventDispatchers.FEATURE_REEL_STOPPING)) {
            dispatcher.fireEvent(eventDispatchers.FEATURE_REEL_STOPPING, evt);
        }
    }
    /**
     * All reels stoped
    */
    protected reelStopped(evt: any) {
        this.reelsStopped.push(true);
        // Checks for total reel stopped event fired along with locked reels to determine how many reels have stopped. if all reels have stopped then flag is turned on to stop the update function.
        if (this.reelsStopped.length >= this.reels.length - this.model.getTotalLockedCoins()) {
            this.stopSpinAll = true;
            this.reelsStopped.length = 0;
            this.model.anticipationSpin.length = 0;
            delayedCall('spinComplete',100,()=>{
                killDelayedCall('spinComplete')
                dispatcher.fireEvent(eventDispatchers.ON_FEATURE_SPIN_COMPLETE);
            })
        }
        dispatcher.fireEvent(eventDispatchers.SHOW_SYMBOL_ON_REEL, evt)
    }
}